import { IDialogContentStyles, IDialogFooterStyles, IDialogStyles } from '@fluentui/react';

import { IH2OTheme } from '../../models/components.models';
import { FontSizes, FontWeights, Sizes } from '../../themes/styles';

export const dialogStylesDefault = (theme: IH2OTheme): Partial<IDialogStyles> => ({
  root: { backgroundColor: theme.palette?.gray900_a_60 },
  main: { borderRadius: Sizes.borderRadius, boxShadow: `${theme.palette?.black_a_4} 0 5px 26px`, padding: 24 },
});

export const dialogContentStylesDefault = (theme: IH2OTheme): Partial<IDialogContentStyles> => ({
  title: {
    padding: 0,
    paddingBottom: 28,
    color: theme.semanticColors?.textQuaternary,
    fontWeight: FontWeights.normal,
    fontSize: FontSizes.xlarge,
  },
  topButton: {
    padding: 0,
    '.ms-Button': {
      width: 16,
      height: 16,
      // Fluent pads the button and margins the glyph (0 4px each), so a 16px icon needs 24px and
      // overflows this 16px box, making the dialog content scroll horizontally. The box is already
      // glyph-sized, so drop both.
      padding: 0,
      '.ms-Button-icon': {
        margin: 0,
      },
    },
  },
  inner: {
    padding: 0,
    color: theme.palette?.gray700,
  },
});

export const dialogFooterStylesDefault: Partial<IDialogFooterStyles> = {
  actions: {
    marginTop: 22,
  },
  actionsRight: {
    marginRight: 0,
    lineHeight: 0,
  },
  action: {
    '& .ButtonContainer-root:not(:first-child)': {
      marginLeft: 8,
    },
  },
};
